module.exports = __webpack_public_path__ + "static/media/ucilogo.b72f656d.png";